import { render, staticRenderFns } from "./BtnDetails.vue?vue&type=template&id=b1211924"
import script from "./BtnDetails.vue?vue&type=script&lang=js"
export * from "./BtnDetails.vue?vue&type=script&lang=js"
import style0 from "./BtnDetails.vue?vue&type=style&index=0&id=b1211924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports